import { Record } from "immutable";

import createFromJS from "../../createFromJS";

export const WelcomeTemplateRecord = Record({
  id: null,
  label: null,
  icon: null,
  category: null,
  creator: null,
  description: null
});

createFromJS.registerCallback("WelcomeTemplateRecord", createFromJS.createPrimitiveCallback(WelcomeTemplateRecord));
